import {useCallback, useRef, type ReactElement} from 'react';
import {toast, type ToastT} from 'sonner';

type UseUpdateToastProps = {
  id: string;
};

type ToastOptions = Omit<ToastT, 'id'>;

export function useUpdateToast({id}: UseUpdateToastProps) {
  const toastIdRef = useRef<string>('');
  const getToastOptions = useCallback(
    (options?: ToastOptions) => ({
      id: toastIdRef.current,
      dismissible: false,
      closeButton: false,
      duration: Infinity,
      ...options,
    }),
    [],
  );

  const closeToast = () => {
    if (toastIdRef.current) {
      toast.dismiss(toastIdRef.current);
      toastIdRef.current = '';
    }
  };

  const createToast = (component: ReactElement, options?: ToastOptions) => {
    toastIdRef.current = id + Date.now();
    toast.custom(() => component, getToastOptions(options));
  };

  const updateToast = (component: ReactElement, options?: ToastOptions) => {
    toast.custom(() => component, getToastOptions(options));
  };

  return {
    toastIdRef,
    closeToast,
    createToast,
    updateToast,
  };
}
